import React from 'react';
import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <div className="notfound-page">
      <span className="notfound-logo gss-marque-produit">GSS-360</span>
      <div className="notfound-code">404</div>
      <div className="notfound-title">Page introuvable</div>
      <div className="notfound-desc">Cette page n'existe pas ou a ete deplacee</div>
      <Link to="/" className="gss-btn gss-btn-primary" style={{ marginTop: '32px', letterSpacing: '1px' }}>
        Retour au tableau de bord
      </Link>
    </div>
  );
}

export default NotFound;
